export const MOBILE_LENGTH_BY_CODE = {
  '+91': 10,   // India
  '+93': 9,    // Afghanistan
  '+355': 9,   // Albania
  '+213': 9,   // Algeria
  '+1-684': 10,// American Samoa
  '+376': 6,   // Andorra
  '+244': 9,   // Angola
  '+1-264': 10,// Anguilla
  '+672': 6,   // Antarctica (satellite)
  '+1-268': 10,// Antigua and Barbuda
  '+54': 10,   // Argentina
  '+374': 8,   // Armenia
  '+297': 7,   // Aruba
  '+61': 9,    // Australia
  '+43': 10,   // Austria
  '+994': 9,   // Azerbaijan

  '+1-242': 10,// Bahamas
  '+973': 8,   // Bahrain
  '+880': 10,  // Bangladesh
  '+1-246': 10,// Barbados
  '+375': 9,   // Belarus
  '+32': 9,    // Belgium
  '+501': 7,   // Belize
  '+229': 8,   // Benin
  '+1-441': 10,// Bermuda
  '+975': 8,   // Bhutan
  '+591': 8,   // Bolivia
  '+387': 8,   // Bosnia and Herzegovina
  '+267': 8,   // Botswana
  '+55': 11,   // Brazil
  '+246': 7,   // British Indian Ocean Territory
  '+673': 7,   // Brunei
  '+359': 9,   // Bulgaria
  '+226': 8,   // Burkina Faso
  '+257': 8,   // Burundi

  '+855': 9,   // Cambodia
  '+237': 9,   // Cameroon
  '+1': 10,    // Canada / USA
  '+238': 7,   // Cape Verde
  '+1-345': 10,// Cayman Islands
  '+236': 8,   // Central African Republic
  '+235': 8,   // Chad
  '+56': 9,    // Chile
  '+86': 11,   // China
  '+57': 10,   // Colombia
  '+269': 7,   // Comoros
  '+242': 9,   // Congo
  '+243': 9,   // Congo (DRC)
  '+682': 5,   // Cook Islands
  '+506': 8,   // Costa Rica
  '+225': 10,  // Côte d’Ivoire
  '+385': 9,   // Croatia
  '+53': 8,    // Cuba
  '+357': 8,   // Cyprus
  '+420': 9,   // Czech Republic

  '+45': 8,    // Denmark
  '+253': 8,   // Djibouti
  '+1-767': 10,// Dominica
  '+1-809': 10,// Dominican Republic

  '+593': 9,   // Ecuador
  '+20': 10,   // Egypt
  '+503': 8,   // El Salvador
  '+240': 9,   // Equatorial Guinea
  '+291': 7,   // Eritrea
  '+372': 8,   // Estonia
  '+251': 9,   // Ethiopia

  '+358': 9,   // Finland
  '+33': 9,    // France

  '+995': 9,   // Georgia
  '+49': 10,   // Germany
  '+233': 9,   // Ghana
  '+30': 10,   // Greece
  '+299': 6,   // Greenland
  '+1-473': 10,// Grenada
  '+502': 8,   // Guatemala
  '+224': 9,   // Guinea
  '+62': 10,   // Indonesia
  '+98': 10,   // Iran
  '+964': 10,  // Iraq
  '+353': 9,   // Ireland
  '+972': 9,   // Israel
  '+39': 10,   // Italy

  '+81': 10,   // Japan
  '+962': 9,   // Jordan

  '+7': 10,    // Kazakhstan / Russia
  '+254': 9,   // Kenya
  '+965': 8,   // Kuwait

  '+856': 8,   // Laos
  '+371': 8,   // Latvia
  '+961': 8,   // Lebanon
  '+266': 8,   // Lesotho
  '+231': 8,   // Liberia
  '+218': 9,   // Libya
  '+370': 8,   // Lithuania
  '+352': 9,   // Luxembourg

  '+60': 9,    // Malaysia
  '+960': 7,   // Maldives
  '+223': 8,   // Mali
  '+356': 8,   // Malta
  '+52': 10,   // Mexico
  '+976': 8,   // Mongolia
  '+212': 9,   // Morocco

  '+977': 10,  // Nepal
  '+31': 9,    // Netherlands
  '+64': 9,    // New Zealand
  '+234': 10,  // Nigeria
  '+47': 8,    // Norway

  '+92': 10,   // Pakistan
  '+63': 10,   // Philippines
  '+48': 9,    // Poland
  '+351': 9,   // Portugal

  '+974': 8,   // Qatar

  '+40': 9,    // Romania

  '+966': 9,   // Saudi Arabia
  '+65': 8,    // Singapore
  '+27': 9,    // South Africa
  '+82': 10,   // South Korea
  '+34': 9,    // Spain
  '+94': 9,    // Sri Lanka
  '+46': 9,    // Sweden
  '+41': 9,    // Switzerland

  '+66': 9,    // Thailand
  '+90': 10,   // Turkey

  '+971': 9,   // United Arab Emirates
  '+44': 10,   // United Kingdom

  '+84': 9,    // Vietnam
  '+263': 9,   // Zimbabwe
};
